module.exports = __webpack_public_path__ + "img/5ccb0c27a2575b7649fbcb28c4156144.svg";